import React from 'react';
import './setting.less'
import { BANNER_TYPE } from "./constants";
import InlineSVG from 'react-inlinesvg';
import accentDisable from '../../assets/accent_disable.svg'
import accentOn from '../../assets/accent_on.svg'
import accentOff from '../../assets/accent_off.svg'

function AutoApprovalBanner({
    bannerTitle,
    bannerType,
    newPreference
})  {
    return (
        <div className={`approval-setting-banner 
        ${bannerType === BANNER_TYPE.disableBanner ? "approval-setting-banner-diable" : ""}
        ${bannerType === BANNER_TYPE.onBanner ? "approval-setting-banner-on" : ""}
        ${bannerType === BANNER_TYPE.offBanner ? "approval-setting-banner-off" : ""}`}>
            <span className='approval-setting-banner-accent'>
                <InlineSVG src={bannerType === BANNER_TYPE.disableBanner ? accentDisable : (bannerType === BANNER_TYPE.offBanner ? accentOff : accentOn)}/>
            </span>
            <span className='approval-setting-banner-title'>
                {bannerTitle}
            </span>
        </div>
    )
}

export default AutoApprovalBanner